import Box from '@mui/material/Box';
import InputBase from '@mui/material/InputBase';
import Typography from '@mui/material/Typography';
import React from 'react';

import { fieldSx, labelSx } from './PartsShipmentsHelpers';

export interface ShipmentReferenceFieldsProps {
  note: string;
  ref1: string;
  onNoteChange: (v: string) => void;
  onRef1Change: (v: string) => void;
}

export const ShipmentReferenceFields: React.FC<ShipmentReferenceFieldsProps> = ({
  note,
  ref1,
  onNoteChange,
  onRef1Change,
}) => (
  <>
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography sx={labelSx}>Note</Typography>
      <InputBase
        placeholder="Optional note..."
        value={note}
        onChange={(e) => onNoteChange(e.target.value)}
        multiline
        sx={{
          ...fieldSx,
          flex: 1,
          alignItems: 'stretch',
          '& textarea': { height: '100% !important', resize: 'none' },
        }}
        inputProps={{ 'aria-label': 'Note' }}
      />
    </Box>
    <Box>
      <Typography sx={labelSx}>Reference 1</Typography>
      <InputBase
        value={ref1}
        onChange={(e) => onRef1Change(e.target.value)}
        sx={fieldSx}
        inputProps={{ 'aria-label': 'Reference 1' }}
      />
    </Box>
  </>
);
